var portfolioTransactionAdd = {
	title: "Transaktion hinzufügen",
	subTitle: "Portfolio: {name}",
	buy: "Kauf",
	sell: "Verkauf",
	currentNumberOfShares: "Aktuelle Menge im Portfolio",
	buyDate: "Kaufdatum",
	sellDate: "Verkaufsdatum",
	quantity: "Anzahl/Nennwert",
	buyPrice: "Kaufpreis",
	exchangeRate: "Wechselkurs",
	exchangeRateFormat: "{from}/{to}",
	confirmBtn: "Ok",
	cancelBtn: "Abbrechen",
	buyValueInPortfolioCurrency: "Kaufwert (portfoliowährung)",
	buyValueInNotationCurrency: "Kaufwert (notierungswährung)",
	sellValueInPortfolioCurrency: "Verkaufswert (portfoliowährung)",
	sellValueInNotationCurrency: "Verkaufswert (notierungswährung)",
	sellPrice: "Verkaufspreis",
	transactionType: "Transaktionsart",
	validationErrors: {
		transactionType: {
			invalidInput: "Die Transaktionsart kann entweder Kauf oder Verkauf sein"
		},
		buyDate: {
			invalidInput: "Ungültiges Datumsformat. Gültiges Format JJJJ-MM-TT'T'HH: MM"
		},
		buyPrice: {
			invalidInput: "Ungültiger Preis"
		},
		exchangeRate: {
			invalidInput: "Ungültiger Wechselkurs"
		},
		quantity: {
			invalidInput: "Ungültige Menge",
			limitExceeded: "Limit überschritten"
		}
	}
};
var de = {
	portfolioTransactionAdd: portfolioTransactionAdd
};

export { de as default, portfolioTransactionAdd };
